/**
 * This file still exists for legacy reasons, but any new
 * functionality should be added to the imported function, not here.
 */

import { loadRecordHit as importedLoadRecordHit } from 'js/utils/loadRecordHit';
import { observeTrackingDelivery } from 'js/utils/observeTrackingDelivery';

export const loadRecordHit = () =>
  observeTrackingDelivery('record_hit', importedLoadRecordHit);

export default loadRecordHit;
